import { createUseStyles } from 'react-jss';

import { canHover, FontWeight, ITheme, textOverflowHidden, Transition } from '../../../../styles';

const useStyles = createUseStyles<string, { disabled?: boolean; large?: boolean }>(
  ({ spacing, colors }: ITheme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: ({ large }) => (large ? spacing.xxLarge : spacing.medium),

      padding: ({ large }) => (large ? '24px' : '14px 16px'),

      '&:not(:last-child)': {
        borderBottom: `1px solid ${colors.borderColor}`,
      },

      '& $deleteButton': {
        display: 'none',
      },

      [canHover()]: {
        '&:hover': {
          '& $deleteButton': {
            display: 'inline-block',
          },
        },
      },

      [canHover(false)]: {
        '&:active': {
          '& $deleteButton': {
            display: 'inline-block',
          },
        },
      },
    },
    fileInfo: {
      flex: 1,
      width: 0, // this is needed for text truncate in children
    },
    formatIcon: {
      opacity: ({ disabled }) => (disabled ? 0.5 : 1),
    },
    fileName: {
      color: colors.black,
      fontWeight: FontWeight.SemiBold,
      fontSize: ({ large }) => (large ? 18 : 14),
      ...textOverflowHidden,
    },
    fileSize: {
      color: colors.black,
      opacity: ({ large }) => (large ? 1 : 0.5),
      fontWeight: ({ large }) => (large ? FontWeight.Regular : FontWeight.SemiBold),
      ...textOverflowHidden,
    },
    deleteButton: {
      cursor: 'pointer',

      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',

      [canHover()]: {
        '&:hover': {
          '& > $icon > svg > path': {
            fill: 'var(--x-status-error)',
          },
        },
      },
      [canHover(false)]: {
        '&:active': {
          '& > $icon > svg > path': {
            fill: 'var(--x-status-error)',
          },
        },
      },

      '&[disabled]': {
        cursor: 'not-allowed',

        '& > $icon > svg > path': {
          fill: 'var(--x-icon-color-2) !important',
        },
      },
    },
    icon: {
      display: 'block',

      '& > svg > path': {
        transition: `fill ${Transition.Default} ease-in-out`,
        fill: 'rgba(0, 0, 0, 0.5)',
      },
    },
  }),
  { name: 'file-list-item' },
);

export default useStyles;
